<template>
  <nav class="top">
    <drawer-menu></drawer-menu>
    <user-menu></user-menu>
    <pushed-menu></pushed-menu>
  </nav>
</template>

<script>
import UserMenu from '@/components/menu/UserMenu'
import DrawerMenu from '@/components/menu/DrawerMenu'
import PushedMenu from '@/components/menu/PushedMenu'

export default {
  name: 'TopBar',
  components: {
    UserMenu,
    DrawerMenu,
    PushedMenu
  }
}
</script>

<style lang="sass">
@import './static/sass/variables.sass'
.top
  width: 100%
  background-color: $blue
  position: sticky
  top: 0
  z-index: 99

  ul
    list-style: none

  .material-icons
    margin: auto
    display: inline-block
    vertical-align: middle

  a
    color: $white
    text-decoration: none
</style>



// WEBPACK FOOTER //
// src/components/layouts/TopBar.vue